import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { about, help, myAccount, socialMedia } from '../footerLinks';
import FooterListItem from './FooterListItem';
import StyledBottom from './StyledBottom';
import StyledDivider from './StyledDivider';
import StyledFooterMobile from './StyledFooterMobile';
import StyledList from './StyledList';
import StyledListItem from './StyledListItem';

export type FooterMobileProps = Omit<
  React.HTMLAttributes<HTMLDivElement>,
  'children'
>;

const FooterMobile: React.FC = (props) => {
  const { t } = useTranslation(['common', 'social']);
  return (
    <StyledFooterMobile {...props}>
      <StyledList>
        <FooterListItem primary={t('about')}>
          {about.map(({ url, text }) => (
            <StyledListItem key={`${url}-${t(text)}`}>
              <Link href={url}>{t(text)}</Link>
            </StyledListItem>
          ))}
        </FooterListItem>
        <StyledDivider />
        <FooterListItem primary={t('help')}>
          {help.map(({ url, text }) => (
            <StyledListItem key={`${url}-${t(text)}`}>
              <Link href={url}>{t(text)}</Link>
            </StyledListItem>
          ))}
        </FooterListItem>
        <StyledDivider />
        <FooterListItem primary={t('myAccount')}>
          {myAccount.map(({ url, text }) => (
            <StyledListItem key={`${url}-${t(text)}`}>
              <Link href={url}>{t(text)}</Link>
            </StyledListItem>
          ))}
        </FooterListItem>
        <StyledDivider />
        <FooterListItem primary={t('followUs')}>
          {socialMedia.map(({ url, text }) => (
            <StyledListItem key={`${url}-${text}`}>
              <a
                href={t(`social:${url}`).toString()}
                target='_blank'
                rel='noreferrer'
              >
                {text}
              </a>
            </StyledListItem>
          ))}
        </FooterListItem>
        <StyledDivider />
      </StyledList>
      <StyledBottom />
    </StyledFooterMobile>
  );
};

export default FooterMobile;
